<template>
  <v-main>
    <ChildProfileToolbar
      :full-size-side-drawer="fullSizeDrawer"
      @click:menu="onToolbarMenuClick"
      @click:notifications="show.notificationsDrawer = true"
      @click:add-profile="show.addProfileDialog = true"
    />
    <ProfileNavigationDrawer
      v-model="show.navigationDrawer"
      :mini-variant="!fullSizeDrawer"
    />
    <router-view @add-profile="show.addProfileDialog = true" />

    <NotificationsDrawer v-model="show.notificationsDrawer" />
    <AddProfileDialog v-model="show.addProfileDialog" />
  </v-main>
</template>

<script>
export default {
  name: 'ProfileLayout',
  components: {
    ChildProfileToolbar: () => import('@/components/profiles/ChildProfileToolbar'),
    ProfileNavigationDrawer: () => import('@/components/profiles/navigation-drawer/ProfileNavigationDrawer'),
    NotificationsDrawer: () => import('@/components/drawers/notifications/NotificationsDrawer'),
    AddProfileDialog: () => import('@/components/modals/AddProfileDialog'),
  },
  data() {
    return {
      fullSizeDrawer: true,
      show: {
        navigationDrawer: this.$vuetify.breakpoint.smAndUp,
        notificationsDrawer: false,
        addProfileDialog: false,
      },
    };
  },
  methods: {
    onToolbarMenuClick() {
      if (this.$vuetify.breakpoint.smAndUp) {
        this.fullSizeDrawer = !this.fullSizeDrawer;
      } else {
        this.show.navigationDrawer = !this.show.navigationDrawer;
      }
    },
  },
};
</script>
